var convert = require('./convert'),
    func = convert('mapValues', require('../mapValues'));

func.placeholder = require('./placeholder');
module.exports = func;



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/~/lodash/fp/mapValues.js
// module id = 1347
// module chunks = 1